<template>
  <div class="detail-content">
    <div id="aicourse" v-show="!loading">

        <!-- 课程名 -->
        <div class="primarylists list-mobile">
            <div class="titles clear">
                <img src="../../../static/images/icon-st.jpg"/>
                <div class="title l">{{ course.name }}</div>
            </div>
        </div>

        <!-- 课程大纲 -->
        <div class="Aicourse_header mg-aicourse">
            <div class="Aicourse_header_black">
                <ul v-if="!course.liveStream">
                    <li class="Aicourse_header_inner">

                        <!-- 细节 -->
                        <p class="ArtificialIntelligence-figure_text" v-html="course.synopsis"></p>

                        <div class="Aicourse_table">
                            <ul>
                                <li>
                                    <p>{{ $t("aicourse.category") }} :&nbsp;</p>
                                    <p>{{ course.category }}</p>
                                </li>
                                <li>
                                    <p>{{ $t("new.title44") }} :&nbsp;</p>
                                    <p style="min-width: 120px">
                                        <span v-if="course.startDate != null || course.endDate != null">{{course.startDate ? course.startDate: $t("new.title45")}} ~ {{course.endDate ? course.endDate : $t("new.title45")}}</span>
                                        <span v-if="course.startDate == null && course.endDate == null">{{ $t("new.title45") }}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <!-- Btn：确认 - 开始 - 返回 -->
                        <div class="three-btn">

                            <!-- 确认进度 -->
                            <!--<button v-if="isTeacher" @click="progess({courseId: course.courseId, name: course.name, userId: userId})" class="btn-01">
                                {{ $t("new.title50") }}
                            </button>-->

                            <!-- 开始课程 -->
                            <button v-if="course.categoryCode != 15 && course.categoryCode != 14 && course.categoryCode != 13 && course.categoryCode != 16" @click="start()" class="btn-01">
                                {{ $t("aicourse.beginLearn") }}
                            </button>

                            <!-- 誓约书 -->
                            <button v-if="course.categoryCode == 14 || course.categoryCode == 13" class="btn-01" @click="startBck({courseId: course.courseId, name: course.named})">
                                {{ $t("curriculum.covenant") }}
                            </button>

                            <!-- 调查问卷 -->
                            <button v-if="course.categoryCode == 15 || course.categoryCode == 13 || (course.categoryCode == 14 && course.externalLink != null) || (course.categoryCode == 16 && course.externalLink != null)" @click="startBks({courseId: course.courseId, name: course.named, categoryCode: course.categoryCode, externalLink: course.externalLink})" class="btn-01">
                                {{ $t("curriculum.question") }}
                            </button>

                            <!-- 结课申请 -->
                            <button v-if="course.categoryCode == 15 || course.categoryCode == 14 || course.categoryCode == 13" @click="finished()" class="btn-01">
                                {{ $t("aicourse.endLearn") }}
                            </button>

                            <!-- 返回 -->
                            <button @click="back()" class="btn-01 btn-back">
                                <span>{{ $t("common.returnButton") }}</span>
                            </button>
                        </div>
                    </li>
                </ul>

                <!-- Type: Live stream -->
                <ul v-else>
                    <li class="Aicourse_header_inner">
                        <template>
                            <div v-if="course.isUrlFb" class="lkt-livestream" v-html="course.synopsis"></div>
                            <div v-else class="lkt-livestream" v-html="course.synopsis"></div>
                        </template>
                        <div class="three-btn" v-if="mobile" style="margin-top:0">
                            <button @click="back()" class="btn-01 btn-back">
                            <span>{{ $t("common.returnButton") }}</span>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 课程详情 -->
        <div class="Aicourse_list-1">
            <ul>
                <li v-if="course.title1 !== '' && course.title1 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath1 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath1" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title1 }}
                        </p>
                        <p class="Aicourse_font_p-1" v-html="course.content1"></p>
                    </div>
                </li>
                <li v-if="course.title2 !== '' && course.title2 !== null">
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title2 }}
                        </p>
                        <p class="Aicourse_font_p-1" v-html="course.content2"></p>
                    </div>
                    <div class="div_img">
                        <img :src="course.imgPath2 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath2" alt="/" />
                    </div>
                </li>
                <li v-if="course.title3 !== '' && course.title3 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath3 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath3" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title3 }}
                        </p>
                        <p class="Aicourse_font_p-1" v-html="course.content3"></p>
                    </div>
                </li>
                <li v-if="course.title4 !== '' && course.title4 !== null">
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title4 }}
                        </p>
                        <p class="Aicourse_font_p-1" v-html="course.content4"></p>
                    </div>
                    <div class="div_img">
                        <img :src="course.imgPath4 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath4" alt="/" />
                    </div>
                </li>
                <li v-if="course.title5 !== '' && course.title5 !== null">
                    <div class="div_img">
                        <img :src="course.imgPath5 === '/file' ? '../../../static/images/temppic.jpg' : course.imgPath5" alt="/" />
                    </div>
                    <div class="div-title">
                        <p>
                            <span></span>
                            {{ course.title5 }}
                        </p>
                        <p class="Aicourse_font_p-1" v-html="course.content5"></p>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Loading -->
    <loading class="loading--lesson" :showLoading="loading" />

    <!-- 弹出：结课申请 -->
    <el-dialog custom-class="class1" style="padding: 0 20px;" :title="$t('new.title19')" :visible.sync="isShow" :modal="true" :width="setDialogWidth()" :center="true">
        <template v-if="curriculumInfo != null">
            <div style="vertical-align: middle; text-align: center;">
                <el-timeline style="display: inline-block; text-align: left;">
                    <el-timeline-item style="color: white;" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp1">
                        {{$t("new.title20")}}
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp2">
                        {{$t("new.title22")}}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp2">
                        {{$t("new.title22") }}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep2 == 0" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp2">
                        {{ $t("new.title22") }}（{{curriculumInfo.ratio2}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 1 && curriculumInfo.isExamShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 2 && curriculumInfo.isExamShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep3 == 0 && curriculumInfo.isExamShow == 1" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp3">
                        {{ $t("curriculum.exam") }}（{{curriculumInfo.ratio3}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep5 == 1 && curriculumInfo.isCovenantShow == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if=" curriculumInfo.isShowStep5 == 2 && curriculumInfo.isCovenantShow == 1" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if=" curriculumInfo.isShowStep5 == 0 && curriculumInfo.isCovenantShow == 1" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp5">
                        {{ $t("curriculum.covenant") }}（{{curriculumInfo.ratio1}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 1 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 2 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep4 == 0 && curriculumInfo.isQuestionnaireShow == 1 && curriculumInfo.externalLink == null" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp4">
                        {{ $t("new.title33") }}（{{curriculumInfo.ratio4}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 1" icon="el-icon-check" size="large" color="#0bbd87" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 2" icon="el-icon-minus" size="large" color="#3399FF" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                    <el-timeline-item v-if="curriculumInfo.isShowStep6 == 0" icon="el-icon-s-flag" size="large" :timestamp="curriculumInfo.timestamp6">
                        {{ $t("new.title21") }}（{{curriculumInfo.ratio5}}）
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div v-if="(curriculumInfo.isShowStep1 != 1 || curriculumInfo.isShowStep2 != 1 || curriculumInfo.isShowStep3 != 1 || curriculumInfo.isShowStep4 != 1 || curriculumInfo.isShowStep5 != 1) && curriculumInfo.isFinished == 0">
                <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
            </div>
            <div v-if="curriculumInfo.isFinished == 1">
                <div class="SubmitPaper_pnn">{{ $t("new.title34") }}</div>
            </div>
            <div class="btn-finish-aircourse" v-if=" curriculumInfo.isShowStep1 == 1 && curriculumInfo.isShowStep2 == 1 && curriculumInfo.isShowStep3 == 1 && curriculumInfo.isShowStep4 == 1 && curriculumInfo.isShowStep5 == 1 && curriculumInfo.isFinished == 0">
                <div class="SubmitPaper_pn" @click="submitFinishCourse">
                    {{ $t("new.title34") }}
                </div>
            </div>
        </template>
    </el-dialog>
  </div>
</template>
<script>
    import { mapState } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        name: "scheduleAicourse",
        data() {
            return {
                course: {},
                curriculumInfo: {},
                importantCourse: [],
                userId: null,
                isTeacher: false,
                status: 0,
                isShow: false,
                loading: false
            };
        },
        created() {
            this.$autoLogin().then(
                () => {
                    this.init();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        components: {
            loading            
        },
        computed: {
            // 从商店获取数据
            ...mapState({
                mobile: (state) => state.header.mobile,
                history: (state) => state.header.history
            })
        },
        methods: {
            init: async function () {
                // 打开加载
                this.loading = true;

                // ID: 课程
                let courseId = this.$route.query.buyCourseId;

                // 学生信息
                let userType = window.sessionStorage.getItem("userType");
                this.isTeacher = parseInt(userType) != 2 ? true : false;
                this.userId = window.sessionStorage.getItem("id");

                // 获取课程信息
                this.course = await this.getCoursePurchaseDetails(courseId);

                // 平台课
                this.importantCourse = await this.getImportantCourses();

                // 获取学生的课程状态
                this.status = await this.getExamStatus({courseId: courseId, studentId: this.userId});

                // 获取课程类型信息
                this.course.categoryCode = await this.getCourseCategory(courseId);

                // 自动更新 api 。 课程开始 [13, 14, 15]
                this.beginSpecial(this.course);

                // Đóng loading
                this.loading = false;
            },
            
            beginSpecial: async function (course) {
                if (course.categoryCode == 13 || course.categoryCode == 14 || course.categoryCode == 15) {
                    await this.startStudy(course.courseId);
                    await this.updateStudyTime({courseId: course.courseId});
                }
            },

            // 获取课程详情
            getCoursePurchaseDetails: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/getScheduleCoursePurchaseDetails", {
                            languageType: this.$lang(),
                            courseId: courseId,
                        })
                        .then((response) => {
                            let course = {
                                courseId: courseId,
                                category: response.data.courseCategory,
                                cover: response.data.courseCover,
                                language: response.data.courseLanguageName,
                                learnTerm: response.data.courseLearnTerm,
                                price: response.data.coursePrice,
                                name: response.data.courseName,
                                synopsis: response.data.courseSynopsis,
                                snopsisPath: response.data.courseSynopsisPath,
                                type: response.data.courseType,
                                endDate: response.data.endDate,
                                imgPath1: response.data.imgPath1,
                                imgPath2: response.data.imgPath2,
                                imgPath3: response.data.imgPath3,
                                imgPath4: response.data.imgPath4,
                                imgPath5: response.data.imgPath5,
                                covenant: response.data.isCovenant,
                                startDate: response.data.startDate,
                                startStudy: response.data.startStudy,
                                title1: response.data.title1,
                                title2: response.data.title2,
                                title3: response.data.title3,
                                title4: response.data.title4,
                                title5: response.data.title5,
                                content1: response.data.content1,
                                content2: response.data.content2,
                                content3: response.data.content3,
                                content4: response.data.content4,
                                content5: response.data.content5
                            }
                            
                            let result =  this.convertSynopsis(course);
                            resolve(result);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 查看直播课程
            convertSynopsis: function (course) {
                // regex
                let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
                let regexFB = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/)(www\.)facebook\.com.*$/);

                course["isUrl"] = false;
                course["isUrlFb"] = false;

                if (regex.test(course.synopsis)) {

                    course["isUrl"] = true;
                    let url = course.synopsis.split("\r\n");

                    if (regexFB.test(course.synopsis)) {
                        course["isUrlFb"] = true;
                        course.synopsis = `<iframe src="${url[1]}" style='border:none;overflow:hidden;width:100%;height:100%' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share' allowFullScreen='true'></iframe>`;
                    } else {
                        course.synopsis = `<iframe style='width:100%;height:100%' src="${url[1]}" frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>`;
                    }
                }

                return course;
            },

            // 获取课程进度
            getCurriculumInfo: function (courseId) {                
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getScheduleCurriculumInfo", {
                        courseId: courseId,
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            //  课程状态
            getExamStatus: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getScheduleExamStatus", {
                            courseId: params.courseId,
                            studentId: params.studentId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 平台课
            getImportantCourses: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getImportantCourses", {
                            languageType: this.$lang(),
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 课程开始处理
            start: async function () {

                let imTS = this.importantCourse.findIndex(item => item.courseId == this.course.courseId);

                // 对于状态为 != -1 的课程
                if (this.status == -1 && imTS < 0 ) {
                    this.$alert(window.vm.$i18n.t("new.title106"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    });
                    return;
                }

                let dateStatus = await this.getsingleCoursePeriodDate(this.course.courseId);

                // 查看课程状态
                if (dateStatus == 1) {
                    this.$message.warning(window.vm.$i18n.t("new.title40"));
                    return;
                }

                if (dateStatus == 2) {
                    this.$message.warning(window.vm.$i18n.t("new.title41"));
                    return;
                }

                if (dateStatus == 3) {
                    this.$message.warning(window.vm.$i18n.t("new.title91").replace("{0}", response.data.dependencyStateName));
                    return;
                }
                
                if (dateStatus == 4) {
                    this.$message.warning(window.vm.$i18n.t("new.title92").replace("{0}", response.data.dependencyStateName).replace("{1}", response.data.dependencyEndPrompting));
                    return;
                }

                // 开始课程

                if (this.course.startStudy > 0) {
                    this.begin({courseId: this.course.courseId, name: this.course.name, type: this.course.type});
                } else {
                    this.$confirm(window.vm.$i18n.t("js.beginLearning"), window.vm.$i18n.t("js.hint"), {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        cancelButtonText: window.vm.$i18n.t("js.cancel"),
                        cancelButtonClass: "btn-custom-cancel",
                    })
                    .then(() => {
                        this.begin({courseId: this.course.courseId, name: this.course.name, type: this.course.type});
                    })
                    .catch(() => {});
                }
            },

            // 开始课程
            begin: async function (param) {
                let status = await this.startStudy(param.courseId);

                if (status > 0) {
                    // 进入课程
                    this.jumpLesson({courseId: param.courseId, name: param.name, type: param.type});
                } else {
                    this.$message.warning(window.vm.$i18n.t("community.content"));
                }
            },

            //  调用api开始课程
            startStudy: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/startScheduleStudy", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            getsingleCoursePeriodDate: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getsingleScheduleCoursePeriodDate", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(Number(response.data.num));
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            
            updatecourseFinished: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/updateScheduleCourseFinished", {
                            courseId: params.courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 处理公开调查
            startBks: async function (param) {

                if (parseInt(param.categoryCode) == 13 || parseInt(param.categoryCode) == 15) {
                    this.beginBks({courseId: param.courseId, name: param.nam});
                    return;
                }

                if (parseInt(param.categoryCode) == 16) {
                    let status = await this.updatecourseFinished({courseId: param.courseId});
                    window.open(param.externalLink);
                    return;
                }
            },

            // 打开誓约书
            beginBks: function (params) {
                this.$router.push({
                    path: "exam/covenant",
                    query: {
                        prev: "AICOURSE",
                        courseId: params.courseId,
                        courseName: params.name,
                        templateType: 1,
                        type: 1,
                    },
                });
            },

            //  打开调查问卷
            startBck: function (param) {
                this.$router.push({
                    path: "exam/covenant",
                    query: {
                        prev: "AICOURSE",
                        courseId: param.courseId,
                        courseName: param.name,
                        templateType: 0,
                        type: 2,
                    },
                });
            },

            // 获取课程类型信息
            getCourseCategory: function (courseId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCategory", {
                            courseId: courseId,
                        })
                        .then((response) => {
                            resolve(response.data.courseCategoryCode);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 更新开始时间
            updateStudyTime: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/updateScheduleStudyTime", {
                            courseId: params.courseId,
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // 转到目录
            jumpLesson: async function (param) {
                await this.updateStudyTime({courseId: param.courseId})
                let outlineInfo = {
                    courseId: param.courseId,
                    courseName: param.name,
                };
                this.$router.push({
                    path: "/home/schedule/schedule_curriculum",
                    query: {
                        outlineInfo: JSON.stringify(outlineInfo),
                        courseType: param.type
                    },
                });
            },
            
            // 确认进度
            progess: function (param) {
                this.$router.push({
                    path: "learnProgressList",
                    query: {
                        courseId: param.courseId,
                        userId: param.userId,
                        courseName: param.name,
                    },
                });
            },

            // 回来
            back: function () {
                
                // let routeName = this.history == null ? "/home/scheduleSchoolBusiness" : this.history;
                // this.$router.push(routeName);

                if (this.checkGeneralEnvironment() == 4 || this.checkGeneralEnvironment() == 0) {
                    let routeName = this.history == null ? "/home/SchoolBusiness_new" : this.history;
                    this.$router.push(routeName);
                } else {
                    let routeName = this.history == null ? "/home/scheduleSchoolBusiness" : this.history;
                    this.$router.push(routeName);
                }
            },

            // Độ rộng của cpn tiến độ
            setDialogWidth: function () {
                let val = document.body.clientWidth;
                const def = 1024;
                if (val < def) {
                    this.dialogWidth = "90%";
                } else {
                    this.dialogWidth = "40%";
                }

                return this.dialogWidth;
            },

            // 结束课程
            finished: async function () {
                if (this.status == -1) {
                    this.$alert(window.vm.$i18n.t("new.title107"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    });
                    return;
                }

                // 获取课程进度信息
                this.curriculumInfo = await this.getCurriculumInfo(this.course.courseId);

                // Mở cpn kết thúc khóa học
                this.isShow = true;
            },

            // 结尾
            submitFinishCourse: function () {
                this.$confirm(window.vm.$i18n.t("new.title35"), window.vm.$i18n.t("js.hint"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                }).then(async () => {
                    await this.updatecourseFinished(this.course.courseId);
                    this.isShow = false;
                });
            },
        },
    };
</script>
<style scoped>
    .lkt-livestream {
        max-width: 1180px;
        height: 640px;
        min-height: 300px;
    }
    @media (max-width: 760px) {
        .lkt-livestream {
            height: 460px;
        }
    }
    @media (max-width: 480px) {
        .lkt-livestream {
            height: 300px;
        }
    }
    /* header */
    .Aicourse_header {
        max-width: 1180px;
        min-width: 480px;
        width: calc(100% - 40px);
        margin: 0 auto;
        background-image: url(../../../static/images/bg/aicourse_bg1.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        /*height: 570px;*/
        margin-bottom: 30px;
    }

    .Aicourse_header_black {
        background-color: rgba(0, 0, 0, 0.6);
        padding: 25px;
        border-radius: 10px;
        /*height: 520px;*/
        padding-top: 15px;
    }

    .Aicourse_header_top {
        text-align: left;
        color: #fafafa;
        letter-spacing: 1px;
        margin-bottom: 50px;
        font-weight: 400;
    }

    .Aicourse_header_top p {
        text-align: left;
        color: #fafafa;
        letter-spacing: 1px;
        font-weight: 400;
    }

    .Aicourse_header_top .artificialIntelligence p {
        font-family: Artifical;
    }

    .Aicourse_header_top .HorizontalLine {
        width: 30px;
        height: 1px;
        background-color: #30d5c8;
        border-radius: 20px;
        margin-top: 5px;
    }

    .Aicourse_header_top .HorizontalLine1 {
        background-color: rgb(255, 112, 66);
    }

    .Aicourse_header_inner {
        text-align: center;
        font-family: Arial;
        /*width: 490px;*/
        margin: 0 auto;
    }

    .Aicourse_header_inner p:nth-child(1) {
        font-size: 48px;
        letter-spacing: 1px;
        color: #fafafa;
        font-family: Arial;
        font-weight: 400;
        margin-bottom: 30px;
    }

    .Aicourse_header_inner p:nth-child(2) {
        font-size: 14px;
        letter-spacing: 1px;
        color: #e8e6e6;
        /* font-family: lato-light, lato, sans-serif;
  font-weight: 400; */
        font-family: Arial;
        font-weight: 200;
        font-style: normal;
        margin-bottom: 40px;
        line-height: 17px;
    }

    .Aicourse_header_inner button {
        line-height: 20px;
        padding: 6px 35px;
        font-size: 13px;
        color: #fafafa;
        font-family: Arial;
        font-weight: 400;
        background-color: unset;
        border-radius: 20px;
        border: 2px #fff solid;
        margin-bottom: 10px;
        margin-top: 20px;
        transition: 0.5s ease;
    }

    .Aicourse_header_inner button:hover {
        color: #ffffff;
        border: 2px #fafafa solid;
        transition: 0.5s ease;
    }

    .Aicourse_header_inner_img {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
        background: url(../../assets/Aicourse/icon_play.png) no-repeat;
        background-size: cover;
        transition: 0.5s ease-in-out;
    }
    .Aicourse_header_inner_img:hover {
        cursor: pointer;
        background: url(../../assets/Aicourse/icon_play_hover.png) no-repeat;
        background-size: cover;
        transition: 0.5s ease-in-out;
    }

    /* 	.Aicourse_header_inner_img img {
  width: 40px;
  height: 40px;
} */

    .Aicourse_header_inner p:nth-child(5) {
        font-size: 12px;
        letter-spacing: 1px;
        color: rgb(255, 255, 255);
        margin-bottom: 30px;
        text-align: center;
    }

    /* .Aicourse_box .Aicourse_box_top p:nth-child(5) {
  margin-top: 30px;
  padding: 10px;
  font-size: 18px;
  color: #565656;
  font-family: myFont;
  text-align: left;
} */
    .Aicourse_header_inner button:hover {
        background-color: #fff;
        color: #333;
        transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
    }

    /*table*/
    .Aicourse_table {
        max-width: 1180px;
        min-width: 480px;
        width: calc(100% - 60px);
        margin: 0 auto;
    }

    .Aicourse_table ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .Aicourse_table ul > li {
        display: inline-block;
        padding: 10px 0 10px 40px;
        border-left: 1px solid rgba(199, 199, 199, 1);
        /* font-family: museo-slab-w01-100, serif; */
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .Aicourse_table ul > li span {
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
    }

    .Aicourse_table ul > li:first-child {
        border-left: none !important;
    }

    .Aicourse_table ul > li p:nth-child(1) {
        font-size: 14px;
        color: rgb(153, 153, 151);
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
        margin-bottom: 15px;
    }

    .Aicourse_table ul > li p:nth-child(2) {
        font-size: 18px;
        color: #414141;
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 700; */
        margin-bottom: 5px;
    }

    .Aicourse_table ul > li p:nth-child(3) {
        font-size: 11px;
        color: rgb(153, 153, 151);
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
    }

    /* ----- */
    .Aicourse_font_right {
        width: 207px;
        height: 215px;
        float: right;
        border: 0px solid rgba(153, 153, 151, 1);
        background-color: rgba(250, 250, 250, 1);
        border-radius: 15px 15px 15px 15px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
        padding: 20px;
        /*font-family: Artifical-slideshow;*/
        text-align: center;
        margin-top: 100px;
        margin-right: 6px;
    }

    .Aicourse_font_right p:nth-child(1) {
        margin: 0 auto;
        width: 80px;
        margin-top: 10px;
    }

    .Aicourse_font_right p:nth-child(1) img {
        width: 78px;
        height: 48px;
    }

    .Aicourse_font_right p:nth-child(2) {
        margin: 0 auto;
        font-size: 25px;
        color: #414141;
        /*font-family: lato-light, lato, sans-serif;*/
        font-weight: 400;
        margin-top: 20px;
    }

    .Aicourse_font_right p:nth-child(2) > span {
        font-weight: bold;
        font-size: 25px;
        color: #414141 !important;
        /*font-family: lato-light, lato, sans-serif;*/
    }

    .Aicourse_box .Aicourse_box_top p:first-child {
        font-size: 28px;
        color: #565656;
        font-family: myFont;
    }

    .Aicourse_box .Aicourse_box_top p:nth-child(2) {
        width: 280px;
        margin: 0 auto;
        font-size: 40px;
        color: #323232;
        font-family: myFont2;
        text-align: center;
    }

    .Aicourse_box .Aicourse_box_top p:nth-child(2) span {
        display: flex;
        width: 60px;
        height: 4px;
        float: right;
        margin-top: -4px;
        margin-right: 6px;
        background-color: #e91926;
    }

    .Aicourse_list {
        max-width: 1100px;
        min-width: 480px;
        margin: 0 auto;
    }

    .Aicourse_Top {
        width: 100%;
        height: 44px;
        background-color: #323232;
        margin-bottom: 40px;
    }

    .Aicourse_list ul {
        max-width: calc(100% - 60px);
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        zoom: 1;
    }

    .Aicourse_list ul li {
        width: 100%;
        height: 317px;
        margin-top: 50px;
        margin-bottom: 100px;
    }

    .Aicourse_list ul li .Aicourse_font {
        width: 50%;
        position: absolute;
    }

    .Aicourse_list ul li .Aicourse_font2 {
        width: 40%;
        position: absolute;
    }

    .Aicourse_list ul li:nth-child(2n + 1) .Aicourse_font2 {
        float: right;
        position: unset;
    }

    .Aicourse_list ul li .Aicourse_font p:first-child {
        margin-top: 50px;
        font-size: 25px;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        color: rgb(70, 70, 70);
        font-weight: bold;
    }

    .Aicourse_list ul li .Aicourse_font p:first-child span {
        display: flex;
        width: 52px;
        height: 3px;
        float: left;
        position: absolute;
        margin-top: 49px;
        background-color: #e91926;
    }

    .Aicourse_firsli_span {
        background-color: rgb(48, 213, 200) !important;
        margin-top: 60px !important;
    }

    .Aicourse_list ul li .Aicourse_font p:nth-child(2) {
        width: 100%;
        margin-top: 32px;
        font-size: 15px;
        /*font-family: lato-light, lato, sans-serif;*/
        color: #414141;
        font-weight: 400;
        text-align: justify;
    }

    .Aicourse_firsli_p2 {
        width: 540px;
    }

    .Aicourse_list ul li .Aicourse_img {
        float: right;
        max-width: 60%;
        height: 317px;
        display: flex;
        align-items: center;
    }

    .Aicourse_list ul li .Aicourse_img img {
        height: calc(100vw * 0.28);
        max-height: 317px;
        max-width: 100%;
    }

    .Aicourse_list ul li:nth-child(2n) .Aicourse_font {
        float: right;
    }

    .Aicourse_list ul li:nth-child(2n-1) .Aicourse_img {
        position: absolute;
    }

    .Aicourse_blackp {
        max-width: 1024px;
        min-width: 480x;
        width: calc(100% - 100px);
        margin: 0 auto;
        padding-top: 50px;
    }

    .Aicourse_blackp_first {
        font-size: 40px;
        color: rgb(65, 65, 65);
        text-align: left;
        /*font-family: lato-light, lato, sans-serif;*/
        font-weight: 400;
    }

    .Aicourse_blackp_two {
        font-size: 45px;
        color: rgb(70, 70, 70);
        text-align: center;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        margin-top: 200px;
        margin-bottom: 200px;
        font-weight: 700;
    }

    /* last*/
    .ArtificialIntelligence_last {
        width: 100%;
        height: auto;
        min-height: 290px;
        background-image: url(../../assets/index/bg_1.png);
        background-position: 50%;
        /* background-position: center center; */
        background-size: cover;
        position: relative;
        margin-top: 50px;
        background-attachment: fixed;
        /*margin-bottom: 10px;*/
    }

    .ArtificialIntelligence_last-div {
        height: auto;
        min-height: 290px;
        width: 100%;
        padding-top: 80px;
        color: #fafafa;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.65);
        padding-bottom: 2px;
    }

    .ArtificialIntelligence_last h1 {
        /*font-family: jura, sans-serif;*/
        font-size: 20px;
        color: #fafafa;
        font-weight: 400;
        line-height: 24px;
    }

    .ArtificialIntelligence_last-h1 {
        margin-bottom: 50px;
    }

    .ArtificialIntelligence_last p {
        margin-bottom: 10px;
        /*font-family: dinneuzeitgroteskltw01-_812426, sans-serif;*/
        font-size: 60px;
        color: #fafafa;
        font-weight: 700;
    }

    .ArtificialIntelligence_last button {
        line-height: 20px;
        padding: 6px 35px;
        font-size: 13px;
        color: #fff;
        /*font-family: Arial, Helvetica, sans-serif;*/
        background-color: unset;
        border-radius: 20px;
        border: 2px #fff solid;
        transition: 0.5s ease;
    }

    .ArtificialIntelligence_last button:hover {
        background-color: #fff;
        color: #333;
        /* transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s; */
        transition: 0.5s ease;
    }

    .ArtificialIntelligence-figure_text {
        /*height: 76px;*/
        /*width: 755px;*/
        font-family: Arial;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
    }

    .Aicourse_header_inner_lastp {
        color: rgb(250, 250, 250);
        font-size: 12px;
        /* font-family: museo-slab-w01-100, serif;
  font-weight: 400; */
        /*font-family: source-han-sans-simplified-c, sans-serif;*/
        font-weight: 200;
        font-style: normal;
        letter-spacing: 0.050000001986821495em;
    }

    .Aicourse_font_p {
        /*width: 300px !important;*/
        color: #414141 !important;
        font-size: 18px !important;
        /*font-family: jura, sans-serif !important;*/
        font-weight: 400 !important;
        text-align: unset !important;
    }

    .Aicourse_list ul li .Aicourse_font2 p:first-child {
        text-indent: 4px;
    }
    .primarylists .titles .title {
        text-transform: none !important;
    }
    .btn-finish-aircourse {
        text-align: center;
        margin-left: 275px;
    }
    .btn-finish-aircourse .SubmitPaper_pn {
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 20px;
        cursor: pointer;
    }
    @media (max-width: 480px) {
        .btn-finish-aircourse {
            text-align: center;
            margin-left: 95px !important;
        }
    }
</style>
<style>
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
        margin-top: 2px;
    }
</style>




// WEBPACK FOOTER //
// src/views/schedule/scheduleAicourse.vue